import moment from 'moment';

export const formatDateOnly = (date) => moment(date).format('l');
export const formatDate = (date) => moment(date).format('l h:mma');
export const formatDateString = (dateString) => {
  let returnDateString = '';
  try {
    returnDateString = moment(dateString).calendar(null, {
      sameDay: 'h:mma',
      lastDay: '[Yesterday] h:mma',
      lastWeek: 'l',
      sameElse: 'l',
    });
  } catch (e) {
    // Unable to format date string
  }
  return returnDateString;
};
export const getRelativeTime = (start, end) => moment.duration(moment(end || moment.now()).diff(moment(start || moment.now()))).humanize();
export const getTodayAtMidnight = () => {
  const todayAtMidnight = new Date();
  todayAtMidnight.setHours(0, 0, 0, 0);
  return todayAtMidnight;
};
export const getThisWeekAtMidnight = () => {
  const today = new Date();
  const weekAtMidnight = new Date(today.setDate(today.getDate() - today.getDay()));
  weekAtMidnight.setHours(0, 0, 0, 0);
  return weekAtMidnight;
};
export const getThisMonthAtMidnight = () => {
  const today = new Date();
  const monthAtMidnight = new Date(today.getFullYear(), today.getMonth(), 1);
  monthAtMidnight.setHours(0, 0, 0, 0);
  return monthAtMidnight;
};

export const daysRemaining = (checkDate) => {
  const eventdate = moment(checkDate);
  const todaysdate = moment();
  return eventdate.diff(todaysdate, 'days');
};

